import React from "react";
import Header from "./subComponents/header";
import Footer from "./subComponents/footer";
import Patterns from "./subComponents/patterns";
import "./disclaimer.css";
import { useSelector } from "react-redux";

const Disclaimer = () => {
  const reportInfo = useSelector((state) => state?.reportInfo);

  return (
    <div id="" className="disclaimer-page">
      {/* This div provides a starting point for Kendo Pdf print */}
      <div style={{ height: "1px" }} />
      {/* Background Image */}
      <div className="background-image" />
      {/* Patterns */}
      <Patterns />
      {/* Header */}
      <Header />
      {/* Main Body */}
      <main className="disclaimer-page-body">
        <p>Disclaimer</p>
        <span>{reportInfo?.disclaimerTermsCondition}</span>
        <span>
          {/* The system design presented herewith contains certain inherent
          limitations regarding unit claimability during instances of load
          shedding or generator operation. Users are advised to acknowledge the
          following disclaimer: <br></br>
          &nbsp;&nbsp;&nbsp;Non-Claimability during Load Shedding or
          Generator Operation: The system design does not guarantee the
          claimability of units during periods of load shedding or when the
          generator is in operation. Due to the fluctuating power supply and
          potential disruptions in electricity provision, users may experience
          limitations in unit claimability functionality. <br></br>
          &nbsp;&nbsp;&nbsp;Dependency on External
          Power Sources: The functionality of the system design heavily relies
          on consistent and uninterrupted power supply from the grid or
          generator. Any disruptions or inconsistencies in power provision may
          affect the unit claimability process.<br></br>
          &nbsp;&nbsp;&nbsp; Subject to Operational
          Constraints: Users should be aware that operational constraints,
          including but not limited to technical issues, maintenance
          requirements, and unforeseen circumstances, may impact the seamless
          functioning of the unit claimability feature.<br></br>
          &nbsp;&nbsp;&nbsp; No Liability for
          Unclaimed Units: In situations where units become unclaimable due to
          load shedding or generator operation, the system design holds no
          liability for any associated inconveniences, losses, or damages
          incurred by users. <br></br>
          &nbsp;&nbsp;&nbsp;Continuous Improvement Efforts: Efforts are ongoing
          to enhance the robustness and reliability of the system design,
          including measures to mitigate the impact of load shedding or
          generator operation on unit claimability. However, users are advised
          to exercise caution and have contingency plans in place during periods
          of power instability. */}
        </span>
      </main>
      {/* Contact US */}
      <div className="disclaimer-contact-us">
        <h3>Contact Us</h3>
        <p>
          {reportInfo?.companyName}
          <br />
          {reportInfo?.companyAddress}
          <br />
          {reportInfo?.companyPhoneNo}
          <br />
          {reportInfo?.companyEmail}
          <br />
        </p>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Disclaimer;
